import { render, staticRenderFns } from "./WelcomeSitting.vue?vue&type=template&id=43c8faea&"
import script from "./WelcomeSitting.vue?vue&type=script&lang=js&"
export * from "./WelcomeSitting.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSitting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports